import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';
import { CrazyCallConfigService } from './crazycall-config.service';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Configuration } from '../domain/configuration.model';
import { LeadGenerationConfigurationService } from './lead-generation-configuration.service';
import { Store } from '@ngrx/store';
import { IState } from '../../../shared/models/state';
import { Observable } from 'rxjs';
import { flatMap } from 'rxjs/operators';
import { UpdateStyleRequest } from '../domain/UpdateStyleRequest';
import updateFormGroupFromJson from '../../../shared/utils/updateFormGroupFromJson';

@Injectable()
export class LeadGenerationStylesService {
  constructor(
    private appConfigService: AppConfigService,
    private http: HttpClient,
    private fb: FormBuilder,
    private crazyCallConfigService: CrazyCallConfigService,
    private store: Store<IState>,
    private leadGenerationConfiguration: LeadGenerationConfigurationService
  ) {}

  saveDb({ type, body, config }: UpdateStyleRequest): Observable<any> {
    const params = { type };
    return this.http.put(this.updateStylesUrl(config.projectId), body, { params }).pipe(
      flatMap(() => {
        config.activeType = params.type;
        config[`${type.toLowerCase()}Style`] = { custom: body };
        return this.leadGenerationConfiguration.updateConfiguration(config);
      })
    );
  }

  private updateStylesUrl(projectId: number): string {
    return `${this.appConfigService.WEB_CALL_BACKEND_CONFIGURATOR_URL}${
      this.crazyCallConfigService.appId
    }/projects/${projectId}/styles`;
  }

  createPopUpForm(): FormGroup {
    return this.fb.group({
      title: [''],
      description: [''],
      buttonText: [''],
      thanksTitle: [''],
      thanksText: [''],
      fontSize: [''],
      fontStyle: [''],
      theme: [''],
      reverseTheme: [''],
      advanced: [''],
      customCSS: [''],
      customHTML: [''],
      thankYouCustomHTML: [''],
      displayType: [''],
      errorMessage: [''],
      forcedCountryCode: ['']
    });
  }

  createBubbleForm(): FormGroup {
    return this.fb.group({
      submitButtonTextBig: [''],
      title: [''],
      phoneNumberLabel: [''],
      fontSize: [''],
      fontStyle: [''],
      description: [''],
      thanksTitle: [''],
      header: [''],
      closeButtonEnabled: [''],
      theme: [''],
      customCSS: [''],
      customHTML: [''],
      customColor: [''],
      customFontColor: [''],
      customFontSize: [''],
      forcedCountryCode: [''],
      errorMessage: [''],
      callUsText: ['', Validators.maxLength(7)],
      hangupButtonText: [''],
      position: this.fb.group({
        useDefault: [true],
        alignTo: [''],
        sideSpacing: [''],
        bottomSpacing: ['']
      })
    });
  }

  updateForm(popupSettings: FormGroup, config: Configuration, type: string) {
    const result = config[`${type}Style`].custom || {};
    updateFormGroupFromJson(popupSettings, result);
  }
}
